import localforage from 'localforage'
import Offine from './Offline'
import Api from '../core/Api'

class User {
    static getUserData(callback) {
        localforage
            .getItem('profil')
            .then(profil => {
                callback(JSON.parse(profil))
            })
            .catch(err => {
            })
    }

    static getUserInfo() {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('profil')
                .then(profil => {
                    resolve(JSON.parse(profil))
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    static updateOnline(){
        return new Promise((resolve, reject) => {
            User.getUserData(data => {
                let usr = {};

                if(!data.phone){
                    usr.phone = null;
                } else {
                    usr.phone = data.phone
                }

                if(!data.immatriculation){
                    usr.immatriculation = '';
                } else {
                    usr.immatriculation = data.immatriculation
                }

                if(!data.signature64) {
                    usr.signature64 = null
                } else {
                    usr.signature64 = data.signature64
                }

                if(!data.photo64){
                    usr.photo64 = null
                } else {
                    usr.photo64 = data.photo64
                }

                Api
                .init()
                .then(api => {
                    api
                    .put('/me', usr)
                    .then(res => {
                        if(!res.data.hasOwnProperty('errors')){
                            localforage
                            .setItem('profil', JSON.stringify(res.data))
                            .then(resolve(true))
                            .catch(err => reject(err))
                        } else {
                            let errs = {
                                apiMsg: res.data.errors,
                                payload: usr
                            };
                            reject(errs)
                        }
                    })
                        .catch(err => {
                            if(err.response.status === 403 || err.response.status === 404){
                                resolve(true)
                            } else {
                                reject(err)
                            }
                        })
                })
                .catch(err => reject(err))
            })
        })
    }

    updateUser(data, callback){
        localforage
            .setItem('profil', JSON.stringify(data))
            .then(()=> {
                Offine.saveAction({
                action: 'update',
                type: 'User',
                id: data.id
              })
            })
            .catch(err => callback(err))
    }
}

export default User



// WEBPACK FOOTER //
// ./src/js/models/User.js